import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-new",
  "use": "status-new-usage",
  "viewBox": "0 0 58.34 58.34",
  "content": "<symbol viewBox=\"0 0 58.34 58.34\" id=\"status-new\"><circle cx=\"29.17\" cy=\"29.17\" r=\"29.17\" /><path d=\"M41.65 25.84H32.5v-9.15a.83.83 0 0 0-.83-.83h-5a.83.83 0 0 0-.83.83v9.15h-9.15a.83.83 0 0 0-.83.83v5a.83.83 0 0 0 .83.83h9.15v9.15a.83.83 0 0 0 .83.83h5a.83.83 0 0 0 .83-.83V32.5h9.15a.83.83 0 0 0 .83-.83v-5a.83.83 0 0 0-.83-.83z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/status-new.svg
// module id = 5JFf
// module chunks = 1